module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": "is-success",
      "message": "This username is available"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": "is-warning",
      "message": ['Password is too short', 'Password must have at least 8 characters']
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Subject"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a subject"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe96034"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExSimple.vue
// module id = 1073
// module chunks = 5 220